module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/$.fails.js
// module id = 7
// module chunks = 0